// extracted by mini-css-extract-plugin
export default {"badge":"CoveragePromoElement_badge__5uQ3m"};